import React, { useEffect, useState } from "react";
import NoSearch from "./shared/NoSearch";
import SearchServie from "services/search/SearchService";
import { ChannelCard } from "pages/liveTvPage/shared/ChannelCard";

function SearchLiveTv({ data }: any) {
  const channels = data?.tv_channels || [];
  // const [channels, setChannels] = useState<any>([]);

  // useEffect(() => {
  //   const searchAll = async () => {
  //     await SearchServie.searchAll(text).then((res) => {
  //       // console.log("first", res);
  //       setChannels(res.tv_channels);
  //     });
  //   };

  //   searchAll();
  // }, [text]);
  return (
    <div>
      {/* top section */}
      <div className="mb-8 w-[98%] ml-2 mt-8 max-sm:w-full max-sm:mx-0">
        <div>
          <h1 className="text-xl font-semibold text-white lg:text-xl md:text-xl">
            {/* search channels */}
            Live TV
          </h1>
        </div>
      </div>
      {/* card section */}
      {channels.length === 0 && channels ? (
        <NoSearch text="Live TV Channels" />
      ) : (
        <div>
          <div className="mt-4 mb-5 w-[95%] grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 max-sm:mx-auto max-sm:w-full max-sm:gap-4">
            {channels.length > 0 &&
              channels.map((channel: any, i: any) => (
                <div key={i}>
                  <ChannelCard data={channel} img={channel.thumbnail_url} />
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchLiveTv;
